/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Order
 */
export interface Order {
  /**
   *
   * @type {string}
   * @memberof Order
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof Order
   */
  orderId: number
  /**
   *
   * @type {string}
   * @memberof Order
   */
  typeOrder: OrderTypeOrderEnum
  /**
   *
   * @type {string}
   * @memberof Order
   */
  reason: string
  /**
   *
   * @type {string}
   * @memberof Order
   */
  sum: string
  /**
   *
   * @type {string}
   * @memberof Order
   */
  sourceType: OrderSourceTypeEnum
  /**
   *
   * @type {string}
   * @memberof Order
   */
  sourceId?: string
  /**
   *
   * @type {string}
   * @memberof Order
   */
  shopId: string
  /**
   *
   * @type {string}
   * @memberof Order
   */
  shopSalePointId: string
  /**
   *
   * @type {string}
   * @memberof Order
   */
  shopPaymentPointId: string
  /**
   *
   * @type {string}
   * @memberof Order
   */
  parentId?: string
  /**
   *
   * @type {number}
   * @memberof Order
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof Order
   */
  updatedAt: number
}

/**
 * @export
 */
export const OrderTypeOrderEnum = {
  Add: 'ADD',
  Remove: 'REMOVE',
} as const
export type OrderTypeOrderEnum =
  (typeof OrderTypeOrderEnum)[keyof typeof OrderTypeOrderEnum]

/**
 * @export
 */
export const OrderSourceTypeEnum = {
  Shops: 'SHOPS',
  Items: 'ITEMS',
  Users: 'USERS',
  Sales: 'SALES',
  Commissions: 'COMMISSIONS',
  Others: 'OTHERS',
  ShopSalePoints: 'SHOP_SALE_POINTS',
  ShopPaymentPoints: 'SHOP_PAYMENT_POINTS',
} as const
export type OrderSourceTypeEnum =
  (typeof OrderSourceTypeEnum)[keyof typeof OrderSourceTypeEnum]

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): value is Order {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('orderId' in value) || value['orderId'] === undefined) return false
  if (!('typeOrder' in value) || value['typeOrder'] === undefined) return false
  if (!('reason' in value) || value['reason'] === undefined) return false
  if (!('sum' in value) || value['sum'] === undefined) return false
  if (!('sourceType' in value) || value['sourceType'] === undefined)
    return false
  if (!('shopId' in value) || value['shopId'] === undefined) return false
  if (!('shopSalePointId' in value) || value['shopSalePointId'] === undefined)
    return false
  if (
    !('shopPaymentPointId' in value) ||
    value['shopPaymentPointId'] === undefined
  )
    return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function OrderFromJSON(json: any): Order {
  return OrderFromJSONTyped(json, false)
}

export function OrderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Order {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    orderId: json['orderId'],
    typeOrder: json['typeOrder'],
    reason: json['reason'],
    sum: json['sum'],
    sourceType: json['sourceType'],
    sourceId: json['sourceId'] == null ? undefined : json['sourceId'],
    shopId: json['shopId'],
    shopSalePointId: json['shopSalePointId'],
    shopPaymentPointId: json['shopPaymentPointId'],
    parentId: json['parentId'] == null ? undefined : json['parentId'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
  }
}

export function OrderToJSON(json: any): Order {
  return OrderToJSONTyped(json, false)
}

export function OrderToJSONTyped(
  value?: Order | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    orderId: value['orderId'],
    typeOrder: value['typeOrder'],
    reason: value['reason'],
    sum: value['sum'],
    sourceType: value['sourceType'],
    sourceId: value['sourceId'],
    shopId: value['shopId'],
    shopSalePointId: value['shopSalePointId'],
    shopPaymentPointId: value['shopPaymentPointId'],
    parentId: value['parentId'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
  }
}
